export const defaultOperaciones = [
  // Operaciones iniciadas (ejemplos con tiempo transcurrido)
  { id: 'op_fab_001', operarioId: 'op1', producto: 'Pieza A', estado: 'iniciada', inicio: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString(), fin: null, unidades: 0, targetUnits: 500, tiempoEstimadoHoras: 4, totalTiempoPausadoMs: 0, ultimaPausaInicio: null, centroTrabajoId: 'ct1_p1',
    consumos: [
      { materialId: 'mat1', unidadesNecesarias: 100 },
      { materialId: 'mat2', unidadesNecesarias: 100 },
      { materialId: 'mat3', unidadesNecesarias: 5 },
    ]
  },
  { id: 'op_fab_003', operarioId: 'op1', producto: 'Pieza C', estado: 'iniciada', inicio: new Date(Date.now() - (2.5 * 60 * 60 * 1000)).toISOString(), fin: null, unidades: 100, targetUnits: 800, tiempoEstimadoHoras: 6, totalTiempoPausadoMs: 0, ultimaPausaInicio: null, centroTrabajoId: 'ct1_p1',
    consumos: [
      { materialId: 'mat4', unidadesNecesarias: 20 },
      { materialId: 'mat5', unidadesNecesarias: 2 },
    ]
  },
  { id: 'op_fab_006', operarioId: 'op2', producto: 'Pieza F', estado: 'iniciada', inicio: new Date(Date.now() - 0.5 * 60 * 60 * 1000).toISOString(), fin: null, unidades: 0, targetUnits: 300, tiempoEstimadoHoras: 5, totalTiempoPausadoMs: 0, ultimaPausaInicio: null, centroTrabajoId: 'ct2_p2',
    consumos: [
      { materialId: 'mat1', unidadesNecesarias: 50 },
      { materialId: 'mat2', unidadesNecesarias: 50 },
      { materialId: 'mat7', unidadesNecesarias: 1 }, // Faltaría stock de motor
    ]
  },
  { id: 'op_fab_015', operarioId: 'op3', producto: 'Producto X1', estado: 'iniciada', inicio: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(), fin: null, unidades: 50, targetUnits: 200, tiempoEstimadoHoras: 4, totalTiempoPausadoMs: 0, ultimaPausaInicio: null, centroTrabajoId: 'ct1_p2',
    consumos: [
      { materialId: 'mat9', unidadesNecesarias: 5 },
      { materialId: 'mat10', unidadesNecesarias: 50 },
    ]
  },
  { id: 'op_fab_016', operarioId: 'op4', producto: 'Producto Y2', estado: 'iniciada', inicio: new Date(Date.now() - 1.5 * 60 * 60 * 1000).toISOString(), fin: null, unidades: 20, targetUnits: 150, tiempoEstimadoHoras: 3, totalTiempoPausadoMs: 0, ultimaPausaInicio: null, centroTrabajoId: 'ct3_p1',
    consumos: [
      { materialId: 'mat11', unidadesNecesarias: 2 },
      { materialId: 'mat12', unidadesNecesarias: 1 },
    ]
  },
  { id: 'op_fab_017', operarioId: 'op1', producto: 'Producto Z3', estado: 'iniciada', inicio: new Date(Date.now() - 0.8 * 60 * 60 * 1000).toISOString(), fin: null, unidades: 10, targetUnits: 100, tiempoEstimadoHoras: 2, totalTiempoPausadoMs: 0, ultimaPausaInicio: null, centroTrabajoId: 'ct2_p1',
    consumos: [
      { materialId: 'mat13', unidadesNecesarias: 3 },
      { materialId: 'mat14', unidadesNecesarias: 10 },
    ]
  },
  
  // Operaciones terminadas (más datos para el resumen)
  { id: 'op_fab_004', operarioId: 'op3', producto: 'Pieza D', estado: 'terminada', inicio: '2023-10-25T10:00:00Z', fin: '2023-10-25T12:00:00Z', unidades: 150, targetUnits: 150, tiempoEstimadoHoras: 2, totalTiempoPausadoMs: 0, ultimaPausaInicio: null, centroTrabajoId: 'ct1_p2',
    consumos: [
      { materialId: 'mat6', unidadesNecesarias: 10 },
    ]
  },
  { id: 'op_fab_012', operarioId: 'op4', producto: 'Pieza X', estado: 'terminada', inicio: '2023-10-24T09:00:00Z', fin: '2023-10-24T11:00:00Z', unidades: 200, targetUnits: 200, tiempoEstimadoHoras: 2, totalTiempoPausadoMs: 0, ultimaPausaInicio: null, centroTrabajoId: 'ct1_p1',
    consumos: [
      { materialId: 'mat1', unidadesNecesarias: 200 },
      { materialId: 'mat2', unidadesNecesarias: 200 },
    ]
  },
  { id: 'op_fab_013', operarioId: 'op1', producto: 'Pieza Y', estado: 'terminada', inicio: '2023-10-23T14:00:00Z', fin: '2023-10-23T16:30:00Z', unidades: 75, targetUnits: 75, tiempoEstimadoHoras: 2.5, totalTiempoPausadoMs: 0, ultimaPausaInicio: null, centroTrabajoId: 'ct2_p1',
    consumos: [
      { materialId: 'mat3', unidadesNecesarias: 10 },
    ]
  },
  { id: 'op_fab_014', operarioId: 'op3', producto: 'Pieza Z', estado: 'terminada', inicio: '2023-10-22T08:00:00Z', fin: '2023-10-22T10:00:00Z', unidades: 300, targetUnits: 300, tiempoEstimadoHoras: 2, totalTiempoPausadoMs: 0, ultimaPausaInicio: null, centroTrabajoId: 'ct3_p1',
    consumos: [
      { materialId: 'mat4', unidadesNecesarias: 50 },
    ]
  },
  { id: 'op_fab_018', operarioId: 'op2', producto: 'Producto A4', estado: 'terminada', inicio: '2023-10-21T11:00:00Z', fin: '2023-10-21T13:00:00Z', unidades: 120, targetUnits: 120, tiempoEstimadoHoras: 2, totalTiempoPausadoMs: 0, ultimaPausaInicio: null, centroTrabajoId: 'ct1_p3',
    consumos: [
      { materialId: 'mat15', unidadesNecesarias: 5 },
    ]
  },
  { id: 'op_fab_019', operarioId: 'op4', producto: 'Producto B5', estado: 'terminada', inicio: '2023-10-20T09:30:00Z', fin: '2023-10-20T11:30:00Z', unidades: 90, targetUnits: 90, tiempoEstimadoHoras: 2, totalTiempoPausadoMs: 0, ultimaPausaInicio: null, centroTrabajoId: 'ct2_p2',
    consumos: [
      { materialId: 'mat16', unidadesNecesarias: 10 },
    ]
  },
  
  // Operaciones pendientes (más operaciones añadidas)
  { id: 'op_fab_002', operarioId: null, producto: 'Pieza B', estado: 'pendiente', inicio: null, fin: null, unidades: 0, targetUnits: 400, tiempoEstimadoHoras: 2, totalTiempoPausadoMs: 0, ultimaPausaInicio: null, centroTrabajoId: 'ct2_p1',
    consumos: [
      { materialId: 'mat1', unidadesNecesarias: 300 },
      { materialId: 'mat2', unidadesNecesarias: 300 },
    ]
  },
  { id: 'op_fab_005', operarioId: null, producto: 'Pieza E', estado: 'pendiente', inicio: null, fin: null, unidades: 0, targetUnits: 250, tiempoEstimadoHoras: 3, totalTiempoPausadoMs: 0, ultimaPausaInicio: null, centroTrabajoId: 'ct3_p1',
    consumos: [
      { materialId: 'mat5', unidadesNecesarias: 1 },
      { materialId: 'mat6', unidadesNecesarias: 5 },
    ]
  },
  { id: 'op_fab_007', operarioId: null, producto: 'Pieza G', estado: 'pendiente', inicio: null, fin: null, unidades: 0, targetUnits: 100, tiempoEstimadoHoras: 1, totalTiempoPausadoMs: 0, ultimaPausaInicio: null, centroTrabajoId: 'ct1_p3',
    consumos: [
      { materialId: 'mat8', unidadesNecesarias: 10 },
    ]
  },
  { id: 'op_fab_008', operarioId: null, producto: 'Pieza H', estado: 'pendiente', inicio: null, fin: null, unidades: 0, targetUnits: 600, tiempoEstimadoHoras: 4, totalTiempoPausadoMs: 0, ultimaPausaInicio: null, centroTrabajoId: 'ct1_p1',
    consumos: [
      { materialId: 'mat3', unidadesNecesarias: 20 }, // Faltaría stock de placa
    ]
  },
  { id: 'op_fab_009', operarioId: null, producto: 'Pieza I', estado: 'pendiente', inicio: null, fin: null, unidades: 0, targetUnits: 350, tiempoEstimadoHoras: 2, totalTiempoPausadoMs: 0, ultimaPausaInicio: null, centroTrabajoId: 'ct2_p1',
    consumos: [
      { materialId: 'mat1', unidadesNecesarias: 150 },
      { materialId: 'mat2', unidadesNecesarias: 150 },
    ]
  },
  { id: 'op_fab_010', operarioId: null, producto: 'Pieza J', estado: 'pendiente', inicio: null, fin: null, unidades: 0, targetUnits: 700, tiempoEstimadoHoras: 5, totalTiempoPausadoMs: 0, ultimaPausaInicio: null, centroTrabajoId: 'ct1_p2',
    consumos: [
      { materialId: 'mat4', unidadesNecesarias: 100 },
    ]
  },
  { id: 'op_fab_011', operarioId: null, producto: 'Pieza K', estado: 'pendiente', inicio: null, fin: null, unidades: 0, targetUnits: 120, tiempoEstimadoHoras: 1, totalTiempoPausadoMs: 0, ultimaPausaInicio: null, centroTrabajoId: 'ct3_p1',
    consumos: [
      { materialId: 'mat6', unidadesNecesarias: 20 },
    ]
  },
  { id: 'op_fab_020', operarioId: null, producto: 'Producto C6', estado: 'pendiente', inicio: null, fin: null, unidades: 0, targetUnits: 80, tiempoEstimadoHoras: 1.5, totalTiempoPausadoMs: 0, ultimaPausaInicio: null, centroTrabajoId: 'ct1_p1',
    consumos: [
      { materialId: 'mat17', unidadesNecesarias: 2 },
      { materialId: 'mat18', unidadesNecesarias: 1 }, // Faltaría stock de bomba
    ]
  },
  { id: 'op_fab_021', operarioId: null, producto: 'Producto D7', estado: 'pendiente', inicio: null, fin: null, unidades: 0, targetUnits: 200, tiempoEstimadoHoras: 3, totalTiempoPausadoMs: 0, ultimaPausaInicio: null, centroTrabajoId: 'ct2_p2',
    consumos: [
      { materialId: 'mat19', unidadesNecesarias: 5 },
      { materialId: 'mat20', unidadesNecesarias: 50 },
    ]
  },
  { id: 'op_fab_022', operarioId: null, producto: 'Producto E8', estado: 'pendiente', inicio: null, fin: null, unidades: 0, targetUnits: 450, tiempoEstimadoHoras: 2.5, totalTiempoPausadoMs: 0, ultimaPausaInicio: null, centroTrabajoId: 'ct3_p1',
    consumos: [
      { materialId: 'mat1', unidadesNecesarias: 200 },
      { materialId: 'mat10', unidadesNecesarias: 300 },
    ]
  },
  
  // Operaciones pausadas
  { id: 'op_fab_000', operarioId: 'op2', producto: 'Pieza Pausada', estado: 'pausada', inicio: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(), fin: null, unidades: 50, targetUnits: 300, tiempoEstimadoHoras: 3, totalTiempoPausadoMs: 1 * 60 * 60 * 1000, ultimaPausaInicio: new Date(Date.now() - 0.5 * 60 * 60 * 1000).toISOString(), centroTrabajoId: 'ct1_p1',
    consumos: [
      { materialId: 'mat1', unidadesNecesarias: 80 },
      { materialId: 'mat2', unidadesNecesarias: 80 },
      { materialId: 'mat4', unidadesNecesarias: 10 },
    ]
  },
  { id: 'op_fab_023', operarioId: 'op3', producto: 'Producto F9', estado: 'pausada', inicio: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(), fin: null, unidades: 30, targetUnits: 100, tiempoEstimadoHoras: 2, totalTiempoPausadoMs: 0.5 * 60 * 60 * 1000, ultimaPausaInicio: new Date(Date.now() - 0.2 * 60 * 60 * 1000).toISOString(), centroTrabajoId: 'ct2_p2',
    consumos: [
      { materialId: 'mat9', unidadesNecesarias: 1 },
      { materialId: 'mat10', unidadesNecesarias: 20 },
    ]
  },
];